import PropTypes from 'prop-types';
import React from 'react';

import classNames from 'classnames';
import { Link } from 'react-router-dom';

const CompanyInsightWrapper = ({
  hasAnswer = false,
  showOwnerView = false,
  onClick,
  children,
  testId = '',
}) => {
  const className =
    'relative z-0 flex flex-1 flex-col justify-between items-start p-6 rounded-lg text-sm border-gray-200 bg-white border';

  if (showOwnerView) {
    return (
      <li className={classNames(className, { 'border-dashed': hasAnswer })}>
        {children}
      </li>
    );
  }

  return (
    <Link to="#" onClick={onClick} className="flex">
      <li
        className={classNames(
          className,
          'hover:border-teal-500 hover:shadow-md max-w-full'
        )}
        data-test-id={testId}
      >
        {children}
      </li>
    </Link>
  );
};

CompanyInsightWrapper.propTypes = {
  hasAnswer: PropTypes.bool,
  showOwnerView: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string,
};

export default CompanyInsightWrapper;
